import { Form } from 'antd';
import styled from 'styled-components';
import caution_icon from './icons/caution.svg';
import PassValueForm from './PassValueForm';
import { IFormMultiPaymentValues } from './helpers';
import { formatCurrency } from 'utils/formatCurrency';
import shopService from 'modules/shop/services';
import { Colors, Switch, Text } from '@fozito/common-ui';

const CardFeeDiscount = () => {
  const cashIncentiveConfig = shopService.selectors.cashIncentive();
  const feeCreditCardConfig = shopService.selectors.feeCreditCard();

  if (!feeCreditCardConfig?.enable && !cashIncentiveConfig?.enable) return null;

  return (
    <CardFee>
      <img src={caution_icon} alt="caution_icon" style={{ width: 32, height: 32 }} />
      {!!feeCreditCardConfig?.enable && <Form.Item noStyle name={'enableCardFee'}><SwitchLabel label={
        <PassValueForm
          name={'cardFeeLabel'}
          render={(cardFeeLabel: IFormMultiPaymentValues['cardFeeLabel']) => <>Card Fee: {cardFeeLabel?.percent ? `${cardFeeLabel.percent}% (${formatCurrency(cardFeeLabel.amount)})` : formatCurrency(cardFeeLabel?.amount)}</>}
        />
      } /></Form.Item>}
      {!!cashIncentiveConfig?.enable && <Form.Item noStyle name={'enableIncentive'}><SwitchLabel label={
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const incentivePercent = getFieldValue('incentivePercent');
            const cashIncentiveValue = getFieldValue('cashIncentiveValue');
            const checkIncentiveValue = getFieldValue('checkIncentiveValue');
            const incentive = cashIncentiveValue + checkIncentiveValue;
            return <>Cash/Check Incentive: {incentivePercent ? `${incentivePercent}% (${formatCurrency(incentive)})` : formatCurrency(incentive)}</>;
          }}
        </Form.Item>
      } /></Form.Item>}
    </CardFee>
  );
};

export default CardFeeDiscount;
const SwitchLabel = ({
  onChange,
  label,
  value,
}: {
  label?: any;
  value?: boolean;
  onChange?: (value: boolean) => void;
}) => {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 8 }} >
      <StyledSwitch value={value} onChange={onChange} />
      <Label title_h9_18_semibold >{label}</Label>
    </label>
  );
};

const Label = styled(Text)`
  color: ${Colors.neutral.text[5]};
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  text-align: left;
`;

const StyledSwitch = styled(Switch)`
  margin-right: 8px;
`;
const CardFee = styled.div`
margin-top: 16px;
display: flex;
height: 49px;
justify-content: center;
align-items: center;
gap: 32px;
align-self: stretch;
background: #FFF1F6;
`;
